import React from "react";
import DocumentSigner from "../common/DocumentSigner";
import { OpafDocumentProps } from "./OpafDocumentTypes";

const OpafDocument = (props: OpafDocumentProps) => {
  const { getLetterDetails } = props;
  const targetFolderNames = ["onboarding policy acknowledgment form", "onboarding policy acknowledgement form"];

  return (
    <DocumentSigner
      getLetterDetails={getLetterDetails}
      targetFolderNames={targetFolderNames}
    />
  );
};

export default OpafDocument;
